import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { of } from 'rxjs';
import {
    catchError,
    concatMap,
    map,
    mergeMap,
    takeUntil,
} from 'rxjs/operators';

import { Dependencies } from '../../store';
import { pluck } from '../../store.decorator';
import { PayloadAction } from '../../store.model';
import { listDataObservable } from '../list-data';
import { retrieveBoxesObservable } from '../retrieve-boxes';

import {
    ActionType,
    ListData,
    listDataResult,
    Reload,
    reloadResult,
} from './pulse-widget.action';
import { ScorecardWidgetState } from './pulse-widget.state';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const reload = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
) =>
    action.pipe(
        ofType(ActionType.SCORECARD_WIDGET__RELOAD),
        mergeMap((act) => {
            const rootState = pluck<ScorecardWidgetState>(
                state.value,
                act.storePath,
            );

            return of(null).pipe(
                concatMap(() => {
                    return retrieveBoxesObservable(
                        deps,
                        act.payload.periodTypes
                            ? act.payload.periodTypes
                            : [null],
                        rootState.user.id,
                        null,
                        null,
                        null,
                        null,
                    );
                }),
                map((ret) =>
                    reloadResult(
                        { ...act.payload, scorecardBoxes: ret },
                        act.storePath,
                    ),
                ),
                catchError((err) => {
                    console.log(err);
                    return of(reloadResult({ ...act.payload }, act.storePath));
                }),
                takeUntil(
                    action.pipe(
                        ofType(ActionType.SCORECARD_WIDGET__RELOAD_CANCEL),
                    ),
                ),
            );
        }),
    );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const listData = (
    action: ActionsObservable<PayloadAction<ActionType, ListData>>,
    state: StateObservable<any>,
    deps: Dependencies,
) =>
    action.pipe(
        ofType(ActionType.SCORECARD_WIDGET__LIST_DATA),
        mergeMap((act) => {
            return of(null).pipe(
                concatMap(() => {
                    return listDataObservable(
                        deps,
                        act.payload.scorecardIds,
                        null,
                    );
                }),
                map((ret) =>
                    listDataResult(
                        { ...act.payload, scorecardData: ret },
                        act.storePath,
                    ),
                ),
                catchError((err) => {
                    console.log(err);
                    return of(
                        listDataResult({ ...act.payload }, act.storePath),
                    );
                }),
                takeUntil(
                    action.pipe(
                        ofType(ActionType.SCORECARD_WIDGET__LIST_DATA_CANCEL),
                    ),
                ),
            );
        }),
    );

export const scorecardWidgetEpics = [reload, listData];
